import Checkbox from '@/components/base/Checkbox';

interface CoverageDistrictsFieldProps {
  districts: string[];
  value: string[];
  onChange: (value: string[]) => void;
  label: string;
  hint?: string;
  name?: string;
}

/** Multi-select of operational districts (chosen from the admin geography). */
export default function CoverageDistrictsField({
  districts,
  value,
  onChange,
  label,
  hint,
  name = 'coverageDistricts',
}: CoverageDistrictsFieldProps) {
  const toggle = (district: string) => {
    onChange(
      value.includes(district) ? value.filter((item) => item !== district) : [...value, district],
    );
  };

  return (
    <div className="w-full">
      <span className="mb-1.5 block text-sm font-medium text-foreground-800">{label}</span>
      <div className="grid grid-cols-2 gap-x-4 gap-y-2.5 rounded-md border border-background-300 bg-background-50 p-3.5 sm:grid-cols-3">
        {districts.map((district) => (
          <Checkbox
            key={district}
            name={name}
            checked={value.includes(district)}
            onChange={() => toggle(district)}
            label={district}
          />
        ))}
      </div>
      {hint ? <p className="mt-1 text-xs text-foreground-500">{hint}</p> : null}
    </div>
  );
}